import { render, staticRenderFns } from "./ModalHighlightLOBWidget.vue?vue&type=template&id=0fa93ece&scoped=true&"
import script from "./ModalHighlightLOBWidget.vue?vue&type=script&lang=js&"
export * from "./ModalHighlightLOBWidget.vue?vue&type=script&lang=js&"
import style0 from "./ModalHighlightLOBWidget.vue?vue&type=style&index=0&id=0fa93ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa93ece",
  null
  
)

export default component.exports